import React from 'react';
import PropTypes from 'prop-types';

const TypeInfoPaneItem = ({ infoName, infoVal }) => (
  <div
    style={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      margin: '10px 10px',
      padding: '10px 0',
    }}
  >
    <div style={{ marginLeft: '15px', textTransform: 'uppercase' }}>{infoName}</div>
    <div style={{ fontWeight: 'bold', marginLeft: '15px', textAlign: 'right' }}>{infoVal}</div>
  </div>
);
TypeInfoPaneItem.propTypes = { infoName: PropTypes.string.isRequired, infoVal: PropTypes.string.isRequired };

export default TypeInfoPaneItem;
